import type { UsersReportResponse } from '@/services';
import { Clock, UserCheck, UserPlus, Users, UserX } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

type Summary = UsersReportResponse['summary'];

interface UsersReportSummaryProps {
  summary?: Summary;
  loading?: boolean;
}

const CARDS: { key: keyof Summary; label: string; icon: LucideIcon }[] = [
  { key: 'total', label: 'Usuários', icon: Users },
  { key: 'firstAccess', label: 'Primeiro acesso', icon: UserPlus },
  { key: 'expiredInvites', label: 'Convites expirados', icon: Clock },
  { key: 'active', label: 'Ativos', icon: UserCheck },
  { key: 'inactive', label: 'Inativos', icon: UserX },
];

export function UsersReportSummary({
  summary,
  loading,
}: UsersReportSummaryProps) {
  return (
    <div className='grid w-full grid-cols-2 gap-3 md:grid-cols-3 xl:grid-cols-5'>
      {CARDS.map(card => {
        const Icon = card.icon;
        return (
          <div
            key={card.key}
            className='flex flex-col gap-1 rounded-2xl bg-white px-3 py-3 shadow-[0px_4px_24px_rgba(15,22,30,0.08)] lg:px-4'
          >
            <div className='flex items-center justify-between gap-2'>
              <div className='flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-alba-green-50'>
                <Icon
                  className='h-4 w-4 text-alba-green-500'
                  strokeWidth={1.6}
                />
              </div>
              {loading ? (
                <div className='h-7 w-16 animate-pulse rounded-md bg-alba-gray-200' />
              ) : (
                <span className='font-gotham text-lg font-bold leading-none text-alba-black-500 tabular-nums lg:text-2xl'>
                  {summary?.[card.key] ?? 0}
                </span>
              )}
            </div>
            <span className='text-xs leading-tight text-alba-gray-600 lg:text-sm'>
              {card.label}
            </span>
          </div>
        );
      })}
    </div>
  );
}
